// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"66d28ae7","453":"982fab0a","750":"fe04e2a8"}[chunkId] + ".chunk.js";
};